export const en = {
    nav: {
        home: "Home", about: "About Us", products: "Products",
        contact: "Contact", dealerLocator: "Find Dealer", tagline: "Bond With Quality",
        getInTouch: "Get in Touch",
        changeLanguage: "Change language",
        openMenu: "Open menu",
        closeMenu: "Close menu",
        homeAria: "Unik Biotech Research — home",
        logoAlt: "Unik Biotech Research Logo",
    },
    hero: {
        badge: "ISO 9001:2008 Certified",
        headline: "Unik Biotech Research, trusted by farmers across India.",
        sub: "Quality agricultural inputs for better yield, healthier soil, and sustainable farming since 2005.",
        cta1: "Explore Products", cta2: "Contact Us",
        highlight: "India",
        certified: "Certified",
        isoLabel: "ISO 9001:2008",
    },
    common: {
        yes: "Yes",
        no: "No",
        previous: "Previous",
        next: "Next",
    },
    cookies: {
        aria: "Cookie consent",
        title: "🍪 Cookie Notice",
        message: "We use cookies to improve your browsing experience.",
        policy: "Cookie Policy",
        reject: "Reject",
        accept: "Accept",
    },
    landing: {
        heroSub: "Trusted by farmers across India. Delivering quality agricultural inputs for better yields, healthier soil, and sustainable farming since 2005.",
        heroCta1: "Explore Our Products",
        heroCta2: "Talk to Our Team",
        missionEyebrow: "Our Mission",
        missionHeadingBefore: "Empowering",
        missionHighlight: "Indian Agriculture",
        missionHeadingAfter: "Through Innovation",
        missionText: "At Unik Biotech Research, we combine science, sustainable farming practices, and innovative agricultural solutions to help farmers improve soil health, increase crop productivity, and build a more sustainable future for agriculture.",
        aboutEyebrow: "About Us",
        aboutHeadingBefore: "Growing With Farmers",
        aboutHighlight: "Since 2005",
        aboutP1: "Founded in 2005 in Pimpalgaon Baswant, Nashik, the heart of Maharashtra's grape and pomegranate belt, Unik Biotech Research began with a simple mission: to serve farmers with quality inputs they can trust.",
        aboutP2: "Over two decades, we have grown from a small local manufacturer into an ISO-certified company with more than 100 products, proudly serving over 10,000 farmers across India through research-driven agricultural solutions.",
        aboutCta: "Know More About Our Milestones",
        offerEyebrow: "Our Products",
        offerHeadingBefore: "What We",
        offerHighlight: "Offer",
        offerSub: "Explore a selection of our trusted agricultural solutions developed to improve crop health, enhance productivity, and support sustainable farming practices.",
        offerCta: "Explore More Products",
        offerProducts: [
            { name: "Aminorich", line: "80% amino acids, 18 types for every growth stage", category: "Amino Acids & Biostimulants" },
            { name: "Excess", line: "High-power biostimulant with 12 active types", category: "Amino Acids & Biostimulants" },
            { name: "Unisearich", line: "Pure Ascophyllum seaweed extract", category: "Biostimulant" },
        ],
        networkEyebrow: "Pan India Network",
        networkHeading: "Strong Network.",
        networkHighlight: "Stronger Together.",
        networkSub: "Unik Biotech Research is building a trusted nationwide dealer network that connects quality agricultural solutions with farmers through dependable local support.",
        networkCta: "Become a Dealer",
        networkMapAria: "India distribution network map",
        networkFeatures: [
            { title: "Wide Reach", text: "Expanding access to trusted agricultural inputs across key farming regions." },
            { title: "Trusted Partnerships", text: "Building lasting relationships with dealers who understand local farmers." },
            { title: "Reliable Support", text: "On-ground assistance and timely guidance through every season." },
            { title: "Growth Together", text: "Helping communities grow with quality products and dependable service." },
        ],
        testimonialsBadge: "People Testimonials",
        testimonialsHeadingBefore: "What Our",
        testimonialsHighlight: "Farmers",
        testimonialsHeadingAfter: "Say",
        testimonialsSub: "Real experiences from farmers who trust Unik Biotech Research for better yields, healthier soil, and stronger crops season after season.",
        testimonialsPrev: "Previous testimonial",
        testimonialsNext: "Next testimonial",
        testimonialsGoTo: "Go to testimonial",
        stories: [
            { name: "Ramesh Patil", meta: "Grapes • Nashik", quote: "Berry size improved noticeably after switching to AminoRich. My buyers paid premium prices for the second season in a row." },
            { name: "Sunil Deshmukh", meta: "Cotton • Vidarbha", quote: "Rhyzomax helped my crop recover from monsoon stress. Roots were visibly thicker compared to my neighbour's plot." },
            { name: "Lakshmi Reddy", meta: "Chilli • Guntur", quote: "Three applications of Excess and the canopy was unrecognisable. Branch count nearly doubled, and so did harvest." },
        ],
        ctaEyebrow: "Grow With Unik Biotech Research",
        ctaHeading: "Ready to grow healthier crops and better yields?",
        ctaText: "Partner with our agronomists to find the right inputs for your soil, season and crop, backed by trusted quality and dependable on-ground support.",
        ctaWhatsapp: "Chat on WhatsApp",
    },
    stats: {
        years: "20+", yearsLabel: "Years of Excellence",
        cert: "ISO", certLabel: "9001:2008 Certified",
        customers: "10,000+", customersLabel: "Happy Farmers",
        products: "100+", productsLabel: "Products",
    },
    home: {
        featuredLabel: "Our Products",
        featuredTitle: "Agricultural Solutions Designed for Every Stage of Farming",
        featuredSub: "From soil nutrition to crop protection, our products are developed through years of agricultural research to help farmers achieve healthier crops and better yields.",
        featuredNote: "Helping Indian Farmers Grow Better Crops Since 2005",
        featuredExploreAll: "Explore All Products",
        featuredCards: ["Bio Fertilizers", "Plant Growth Promoters", "Crop Protection", "Micronutrients"],
        explore: "Explore",
        cropsTitle: "Crops We Serve",
        aboutLabel: "Who We Are",
        aboutTitle: "About Unik Biotech Research",
        aboutSub: "Established in 2005 in Nashik, Maharashtra, we are committed to providing the highest quality agricultural inputs to farmers across India. Our ISO 9001:2008 certified facility ensures every product meets the highest standards.",
        aboutCta: "Learn More",
        aboutEyebrow: "About Unik Biotech Research",
        aboutHeading: "Growing Better Agriculture Through Innovation",
        aboutHighlight: "Innovation",
        aboutP1: "At Unik Biotech Research, we are driven by a singular purpose: to empower farmers and build a more sustainable future through science, innovation and trust.",
        aboutP2: "With over two decades of expertise in agricultural biotechnology, we develop high performance products that enhance soil health, improve crop productivity and promote environmental sustainability.",
        aboutP3: "Our modern manufacturing, stringent quality standards and farmer first approach have made us a trusted partner in agriculture across the country.",
        aboutBtn: "Learn More",
        aboutAchievements: [
            { title: "ISO 9001 Certified", sub: "Quality you can rely on" },
            { title: "100+ Products", sub: "Innovative solutions" },
            { title: "20+ Years", sub: "Of agricultural expertise" },
        ],
        aboutFloating: [
            { title: "20+ Years", sub: "Of agricultural expertise and trust" },
            { title: "Sustainable Farming", sub: "Solutions for a better tomorrow" },
            { title: "Research Driven", sub: "Innovation backed by science" },
            { title: "Quality Assured", sub: "Stringent quality at every step" },
        ],
        aboutStatementTitle: "Growing with Farmers Since 2005",
        aboutStatementText: "Helping farmers with innovative biotechnology solutions through quality, research and sustainable practices.",
        ctaTitle: "Ready to improve your yield?",
        ctaSub: "Talk to our Agronomists and find the right product for your crops.",
        ctaEyebrow: "Ready to Grow Better?",
        ctaHeading: "Let's Build a Greener, Stronger Tomorrow.",
        ctaHighlight: "Tomorrow.",
        ctaText: "Partner with Unik Biotech Research for innovative solutions, trusted quality and a sustainable future.",
        ctaCall: "Call Now", ctaWhatsapp: "WhatsApp",
        viewAll: "View All Products",
    },
    why: {
        eyebrow: "Why Choose Unik Biotech Research",
        heading: "Why Thousands of Farmers Choose Unik Biotech Research",
        highlight: "Unik Biotech Research",
        sub: "We combine science, innovation and nature to help farmers grow more. Trusted quality that protects crops and keeps the soil healthy for tomorrow.",
        cards: [
            { title: "Science Backed", desc: "Every product is developed through advanced research and scientific validation." },
            { title: "High Yield Performance", desc: "Formulated to deliver visible results and improve crop productivity." },
            { title: "Quality Assured", desc: "Strict quality control that meets international standards at every step." },
            { title: "Sustainable Farming", desc: "Solutions for healthy soil, better yields and a sustainable future." },
            { title: "Farmer First Approach", desc: "Built to solve real field challenges and support farmers every day." },
            { title: "Innovation Through Research", desc: "Continuous research that creates effective and safe agricultural solutions." },
            { title: "Modern Agricultural Solutions", desc: "New ideas and technology that make farming simpler and more efficient." },
            { title: "ISO Certified", desc: "Backed by an ISO 9001:2008 certified quality management system." },
        ],
        stats: [
            { value: "20+", label: "Years of Excellence" },
            { value: "100+", label: "Premium Products" },
            { value: "10,000+", label: "Farmers Served" },
            { value: "ISO", label: "9001:2008 Certified" },
        ],
    },
    about: {
        hero: "About Us",
        heroSub: "20 years of serving farmers with quality and innovation",
        missionTitle: "Our Mission",
        missionText: "To empower farmers with scientifically advanced, high-quality agricultural inputs that improve crop health, yield, and soil fertility, sustainably and affordably.",
        visionTitle: "Our Vision",
        visionText: "To be the most trusted agricultural inputs brand in India, bridging modern biotechnology with traditional farming wisdom.",
        storyLabel: "Our Roots",
        storyTitle: "Our Story",
        storyText: "Founded in 2005 in Pimpalgaon Baswant, Nashik, the heart of Maharashtra's grape and pomegranate belt, Unik Biotech Research began with a simple mission: serve farmers with quality inputs they can trust. Over two decades, we have grown from a small local manufacturer to an ISO-certified company with 100+ products serving 10,000+ farmers across India.",
        establishedLabel: "Established",
        statEstablished: "Established",
        statLocation: "Location",
        statLocationWrap: "Nashik, MH",
        statProducts: "Products",
        statCert: "Certification",
        statYearsWrap: "20+ Years",
        legacyLabel: "Our Legacy",
        journeyTitle: "Milestones of Success",
        journeySub: "From our humble beginnings to becoming a trusted partner in agriculture, our journey is built on trust, innovation and impact.",
        growTitle: "Let's Grow Together",
        growText: "Join us in our mission to empower farmers with innovative solutions and sustainable growth.",
        growBecome: "Become a Dealer",
        growFind: "Find a Dealer",
        certTitle: "Quality & Certifications",
        valuesTitle: "Our Core Values",
        values: [
            { title: "Quality First", desc: "Every product undergoes rigorous quality checks before reaching farmers." },
            { title: "Farmer Focus", desc: "Our decisions are guided by what is best for the farmer." },
            { title: "Innovation", desc: "We invest in R&D to bring the latest agricultural science to farmers." },
            { title: "Trust", desc: "Building lasting relationships with farmers and dealers since 2005." },
        ],
        certs: [
            { title: "ISO 9001:2008", desc: "ISO 9001:2008 Certified — Quality Management System" },
            { title: "Lab Tested", desc: "Every product is rigorously tested in our lab before dispatch" },
            { title: "Made in Nashik", desc: "Manufactured at Pimpalgaon Baswant, Nashik, Maharashtra" },
        ],
        pageValues: [
            { title: "Quality", desc: "Quality is our foundation. Every product is made with precision and care." },
            { title: "Teamwork", desc: "Together we grow. Our team works collaboratively to achieve excellence." },
            { title: "Innovation", desc: "Pioneering the future of agriculture with continuous innovation." },
            { title: "Punctuality", desc: "Delivering on time, every time. Reliability you can count on." },
        ],
        milestones: [
            { year: "2005", title: "Founded", desc: "Unik Biotech Research was established in Pimpalgaon Baswant, Nashik with a vision to serve farmers." },
            { year: "2008", title: "Built a Strong Foundation", desc: "Strengthened manufacturing of quality agri inputs and built trust at the grassroots level." },
            { year: "2012", title: "Growing Stronger", desc: "Expanded our product range and strengthened distribution across Maharashtra." },
            { year: "2017", title: "Trusted by Thousands", desc: "Reached thousands of farmers and became a dependable agri partner." },
            { year: "2020", title: "ISO Certified", desc: "Achieved ISO 9001:2008 certification for our quality management systems and processes." },
            { year: "2025+", title: "Transforming the Future", desc: "Continuing to innovate with sustainable, effective and farmer-first solutions for a better tomorrow." },
        ],
    },
    products: {
        title: "Our Products",
        sub: "Complete range of agricultural inputs for every need",
        filterLabel: "Filter by Category",
        searchLabel: "Search products...",
        enquire: "Enquire Now",
        viewDetails: "View Details",
        benefits: "Key Benefits",
        composition: "Composition",
        dosage: "Dosage & Application",
        form: "Form",
        packing: "Packing",
        crops: "Suitable Crops",
        close: "Close",
        noResults: "No products found. Try a different category or search.",
        productCountLabel: "Products Found",
        enquireCall: "Enquire: Call +91 7666272741",
        clearSearch: "Clear search",
        badgeMicronutrient: "Micronutrient",
        badgeBiostimulant: "Biostimulant",
        badgeProtection: "Protection",
        badgeSoil: "Soil Conditioner",
        badgeBiofertilizer: "Bio Fertilizer",
        badgeSpreader: "Spreader & Sticker",
        ctaTitle: "Can't find what you're looking for?",
        ctaText: "Our team is here to help you choose the right solution for your crops.",
        ctaBtn: "Talk to Our Experts",
        quickView: "Quick View",
        viewFullDetails: "View Full Product Page",
        backToProducts: "Back to Products",
        notFoundTitle: "Product Not Found",
        notFoundText: "We couldn't find the product you're looking for. It may have been renamed or is no longer listed.",
        notFoundCta: "Browse All Products",
    },
    categories: {
        all: "All Products",
        micronutrient: "Micronutrient Fertilizers",
        biostimulant: "Biostimulants",
        protection: "Crop Protection",
        soil: "Soil Conditioners",
        biofertilizer: "Bio Fertilizers",
        spreader: "Spreaders & Stickers",
    },
    contact: {
        title: "Contact Us",
        sub: "We're here to help you with the best solutions for a healthier and more productive tomorrow.",
        formTitle: "Send us a Message",
        name: "Your Name", namePlaceholder: "Full Name",
        phone: "Phone Number", phonePlaceholder: "Phone Number",
        email: "Email (optional)", emailPlaceholder: "Email Address",
        cropType: "Crop Type", cropPlaceholder: "Select your crop",
        message: "Message", messagePlaceholder: "Message",
        subjectPlaceholder: "Subject",
        submit: "Send Message",
        success: "Message sent successfully! We'll contact you soon.",
        error: "Failed to send. Please try calling us directly.",
        fillError: "Please fill in your name, phone number and message.",
        sending: "Sending...",
        infoTitle: "Get in Touch",
        address: "Address", phone2: "Customer Care", emailLabel: "Email", website: "Website",
        whatsapp: "Chat on WhatsApp",
        whatsappSub: "Get instant response",
        addressLabel: "Our Address",
        emailUs: "Email Us",
        callUs: "Call Us",
        formEyebrow: "Send Us a Message",
        formHeading: "We'd Love to Hear From You",
        formIntro: "Have a question, suggestion or need support? Fill out the form and our team will get back to you soon.",
        locationEyebrow: "Our Location",
        locationHeading: "Find Us Here",
        locationText: "Visit our office for any queries or business discussions. Our team is ready to help you find the right agricultural solutions.",
        viewLargerMap: "View Larger Map",
        mapTitle: "Unik Biotech Research Location",
        addressLines: [
            "Unik Biotech Research",
            "B-178, S.S. Co-Op. Ind. Estate,",
            "Pimpalgaon (B), Tal. Niphad,",
            "Dist. Nashik - 422 209,",
            "Maharashtra, India",
        ],
        mapAddressShort: "B-178, S.S. Co-Op. Ind. Estate, Pimpalgaon (B), Tal. Niphad, Dist. Nashik - 422 209, Maharashtra",
    },
    dealer: {
        title: "Dealer Locator",
        sub: "Join the Unik Biotech Research dealer network and be a part of our mission to empower farmers and build a stronger agricultural future.",
        searchTitle: "Find a Dealer",
        searchSub: "Enter your district or village to locate the nearest authorized dealer",
        district: "District", districtPlaceholder: "e.g. Nashik, Pune, Chhatrapati Sambhajinagar",
        searchBtn: "Find Dealers",
        becomeTitle: "Become a Dealer",
        becomeSub: "Partner with Unik Biotech Research and grow your business with our trusted products, support and guidance.",
        networkTitle: "Our Distribution Network",
        networkSub: "Unik Biotech Research has an extensive dealer network across Maharashtra.",
        applyName: "Full Name", applyPhone: "Phone", applyDistrict: "District", applyVillage: "Village/Town",
        applySubmit: "Apply to Become a Dealer",
        applySuccess: "Application submitted! Our team will contact you within 24 hours.",
        applyErrSub: "Something went wrong. Please try again.",
        applyErrFill: "Please fill in your name, mobile number, city and district.",
        applyErrAgree: "Please agree to be contacted by Unik Biotech Research.",
        applyBtnSubmitting: "Submitting...",
        namePlaceholder: "Your full name",
        villagePlaceholder: "Village or Town",
        foundTitle: "Dealers available in your district!",
        foundDesc: "Please call us for dealer details: +91 7666272741",
        notFoundTitle: "No dealer currently in your area.",
        notFoundDesc: "Apply to become a dealer below or contact us directly.",
        districtsServes: "Districts We Serve",
        headOffice: "Head Office",
        benefits: [
            "Exclusive dealer rights in your area",
            "Full product training & technical support",
            "Attractive margins on 50+ products",
            "Marketing materials & field support",
            "Direct support from Nashik head office"
        ],
        heroHeadingBefore: "Together, Let's",
        heroHighlight: "Grow",
        heroHeadingAfter: "Better",
        findTitle: "Find a Dealer",
        findSub: "Locate your nearest authorized dealer and get genuine products with expert advice.",
        applyNow: "Apply Now",
        formEyebrow: "Become a Dealer",
        formHeading: "Join Our Dealer Network",
        formIntro: "Partner with Unik Biotech Research and grow your business with trusted agricultural solutions, technical support, and a strong dealer network across India.",
        firmLabel: "Business / Firm Name",
        firmPlaceholder: "Your business name",
        mobileLabel: "Mobile Number",
        emailLabel: "Email Address",
        cityLabel: "City",
        cityPlaceholder: "Your city",
        stateLabel: "State",
        selectDistrict: "Select district",
        selectState: "Select state",
        pinLabel: "Pin Code",
        pinPlaceholder: "e.g. 422209",
        experienceLabel: "Years in Agricultural Business",
        selectExperience: "Select Experience",
        productsLabel: "Products Interested In",
        selectProducts: "Select Products",
        existingCustomer: "Existing Customer?",
        messageLabel: "Additional Message",
        messagePlaceholder: "Write your message here...",
        agreeText: "I agree to be contacted by Unik Biotech Research.",
        respondTitleBefore: "We respond within",
        respondHighlight: "24 hours",
        respondSub: "Our team will connect with you shortly.",
        availableEyebrow: "Our Network",
        availableTitle: "Available Dealers",
        availableSub: "Connect with your nearest authorized Unik Biotech Research dealer for genuine products, expert guidance and reliable agricultural solutions.",
        showing: "Showing",
        dealersCount: "Dealers",
        authorizedBadge: "Authorized Dealer",
        availableProducts: "Available Products",
        callDealer: "Call Dealer",
        directions: "Directions",
        statsDealers: "Dealers",
        statsDistricts: "Districts",
        statsYears: "Years of Trust",
        experienceOptions: ["Less than 1 year", "1 – 3 years", "3 – 5 years", "5 – 10 years", "10+ years"],
        productInterests: ["Bio Fertilizers", "Plant Growth Promoters", "Crop Protection", "Micronutrients", "Seaweed Extracts", "All Products"],
        faqTitle: "Frequently Asked Questions",
        faqSub: "Find answers to common questions about becoming an authorized UNIK BIOTECH dealer and using our Dealer Locator.",
        faqs: [
            { question: "Who can become an authorized UNIK BIOTECH dealer?", answer: "Agricultural retailers, distributors, agri-input businesses and entrepreneurs involved in the agriculture sector can apply to become an authorized dealer." },
            { question: "How long does the approval process take?", answer: "Our team reviews dealer applications after submission and contacts eligible applicants once the verification process is complete." },
            { question: "Do I need previous experience in agricultural products?", answer: "Previous experience is beneficial but not mandatory. Our team provides guidance to help new dealers understand our products and processes." },
            { question: "What support does UNIK BIOTECH provide to dealers?", answer: "Dealers receive product information, technical guidance, promotional support and assistance from our sales team." },
            { question: "Can I apply from any state in India?", answer: "Yes. We welcome dealer applications from different regions across India, subject to our dealer network requirements." },
            { question: "How do I locate my nearest dealer?", answer: "Use the Dealer Locator above to search by dealer name, city, district or state." },
        ],
    },
    footer: {
        tagline: "Bond With Quality",
        desc: "Research-driven agricultural solutions trusted by Indian farmers for over two decades.",
        quickLinks: "Quick Links", productsLink: "Products", contactLink: "Contact",
        categories: "Product Categories", address: "Address", phone: "Customer Care",
        rights: "All Rights Reserved.",
        journeyTitle: "Our Journey",
        contactBtn: "Contact Us",
        madeFor: "Made for Indian Agriculture.",
        estLine: "Est. 2005 | Nashik, Maharashtra, India",
        companyAddress: "B-178, S.S. Co-Op. Ind. Estate, Pimpalgaon (B), Tal. Niphad, Dist. Nashik - 422 209",
        journey: [
            { value: "20+", label: "Years of Trust" },
            { value: "ISO 9001:2008", label: "Certified" },
            { value: "100+", label: "Products" },
            { value: "10,000+", label: "Farmers" },
        ],
    },
    cookiePolicy: {
        title: "Cookie Policy",
        subtitle: "This page outlines how cookies may be used on our website. Final policy content will be provided by the client.",
        onThisPage: "On this page",
        sections: [
            {
                id: "what-are-cookies",
                title: "What Are Cookies?",
                paragraphs: [
                    "Cookies are small text files that are placed on your device when you visit a website. They are widely used to make websites work more efficiently and to provide information to site owners.",
                    "When you visit our website, cookies may be stored on your computer, tablet, or mobile device. These files contain information that helps the website recognize your device on subsequent visits.",
                    "Cookies cannot access other information on your device or harm your computer. They are designed to improve your browsing experience by remembering your preferences and enabling certain site functionality.",
                ],
            },
            {
                id: "why-we-use-cookies",
                title: "Why We Use Cookies",
                paragraphs: [
                    "We use cookies to ensure our website functions properly and to understand how visitors interact with our content. This helps us provide a better experience for everyone who uses our site.",
                    "Cookies allow us to remember your settings and preferences, such as language choices or display options, so you do not have to re-enter them each time you visit.",
                    "We may also use cookies to analyze site traffic and usage patterns. This information helps us improve our website design, content, and overall performance.",
                    "Some cookies are essential for the website to operate, while others help us enhance your experience or support our marketing efforts. You can learn more about each category in the sections below.",
                ],
            },
            {
                id: "types-of-cookies",
                title: "Types of Cookies We Use",
                paragraphs: [
                    "We may use several categories of cookies on our website. Essential cookies are required for basic site functionality, such as navigation and access to secure areas.",
                    "Performance and analytics cookies help us understand how visitors use our website by collecting anonymous information about page visits, traffic sources, and user behavior.",
                    "Functionality cookies allow the website to remember choices you make and provide enhanced, personalized features. Marketing cookies may be used to deliver relevant content or measure the effectiveness of our communications.",
                ],
            },
            {
                id: "managing-preferences",
                title: "Managing Your Cookie Preferences",
                paragraphs: [
                    "You have choices regarding how cookies are used on our website. Most web browsers allow you to control cookies through their settings, including the ability to block or delete cookies.",
                    "You can adjust your browser settings to refuse all cookies or to alert you when a cookie is being sent. Please note that disabling certain cookies may affect the functionality of our website and limit your ability to use some features.",
                    "If our website offers a cookie preference tool, you can use it to customize which optional cookies you accept. Your preferences can typically be updated at any time.",
                ],
            },
            {
                id: "third-party-cookies",
                title: "Third-Party Cookies",
                paragraphs: [
                    "Some cookies on our website may be set by third-party services that appear on our pages. These third parties may include analytics providers, embedded content platforms, or social media integrations.",
                    "We do not control the cookies placed by third parties, and their use is governed by the respective third party's privacy and cookie policies. We encourage you to review those policies for more information.",
                    "Third-party cookies may collect information about your browsing activity across different websites. This helps those services provide analytics, advertising, or other features as part of their offerings.",
                ],
            },
            {
                id: "policy-changes",
                title: "Changes to This Cookie Policy",
                paragraphs: [
                    "We may update this Cookie Policy from time to time to reflect changes in our practices, technology, or business operations. When we make changes, we will revise the date at the top or bottom of this page.",
                    "We encourage you to review this policy periodically to stay informed about how we use cookies. Continued use of our website after any updates constitutes your acknowledgment of the revised policy.",
                    "If we make significant changes to how we use cookies, we may provide additional notice on our website or through other appropriate channels.",
                ],
            },
            {
                id: "contact-us",
                title: "Contact Us",
                paragraphs: [
                    "If you have questions about this Cookie Policy or how we use cookies on our website, please contact us using the details provided on our website.",
                    "We will respond to your inquiries as promptly as possible and will be happy to assist with any concerns regarding cookies or your privacy preferences.",
                    "For general information about how we handle personal data, you may also refer to our Privacy Policy, which is available on our website.",
                ],
            },
        ],
    },
    privacyPolicy: {
        title: "Privacy Policy",
        subtitle: "This page describes how we may collect, use, and protect personal information when you visit our website or interact with us online.",
        onThisPage: "On this page",
        sections: [
            {
                id: "introduction",
                title: "Introduction",
                paragraphs: [
                    "This Privacy Policy describes how we may collect, use, and handle personal information when you visit our website, contact us, or interact with our services. We encourage you to read this page to understand our general practices regarding personal data.",
                    "By using our website or providing information to us, you acknowledge that your personal information may be processed as described in this policy. If you do not agree with these practices, you may choose not to use our website or submit personal information through our forms.",
                    "This policy applies to information collected through our website and related online channels. It does not cover information collected offline or through third-party websites that may link to or from our site.",
                ],
            },
            {
                id: "information-we-collect",
                title: "Information We Collect",
                paragraphs: [
                    "We may collect information that you voluntarily provide when you fill out contact forms, request information, subscribe to updates, or otherwise communicate with us. This may include your name, email address, phone number, company name, and the content of your message.",
                    "When you visit our website, we may automatically collect certain technical information such as your browser type, device type, operating system, IP address, referring URLs, and general usage data about how you interact with our pages.",
                    "We may also receive information from third-party service providers that help us operate our website, such as analytics or hosting services. The types of information collected depend on the services used and your browser settings.",
                    "We do not intentionally collect sensitive personal information unless you choose to include it in a message or form submission. Please avoid sending information you do not wish to share through our website.",
                ],
            },
            {
                id: "how-we-use-your-information",
                title: "How We Use Your Information",
                paragraphs: [
                    "We may use the information we collect to respond to your inquiries, provide requested information, and communicate with you about our products, services, or updates where appropriate.",
                    "Technical and usage information may be used to maintain and improve our website, understand visitor preferences, monitor performance, and help us develop content that is relevant to our audience.",
                    "We may also use collected information for internal business purposes, such as record keeping, quality review, and general administration of our online presence.",
                    "We generally process information based on your interaction with our website, our legitimate business interests in operating and improving our services, and, where applicable, your consent.",
                ],
            },
            {
                id: "cookies-and-tracking",
                title: "Cookies and Tracking Technologies",
                paragraphs: [
                    "Our website may use cookies and similar technologies to remember preferences, support basic site functionality, and collect information about how visitors use our pages.",
                    "Cookies are small text files stored on your device by your browser. They may be session cookies, which expire when you close your browser, or persistent cookies, which remain until they expire or are deleted.",
                    "You can usually manage or disable cookies through your browser settings. Please note that restricting cookies may affect certain features or the overall experience of our website.",
                    "Where we use analytics or similar tools, those services may collect aggregated or device-level information to help us understand traffic patterns and site usage. Their use is subject to their own policies.",
                ],
            },
            {
                id: "data-sharing",
                title: "Data Sharing and Third-Party Services",
                paragraphs: [
                    "We do not sell personal information. We may share information with trusted service providers who assist us in operating our website, hosting content, delivering communications, or analyzing site performance.",
                    "These providers may process information on our behalf and are generally expected to use it only for the services they perform for us. We may also share information when required by applicable law, regulation, legal process, or governmental request.",
                    "Our website may contain links to external websites or services that are not operated by us. We are not responsible for the privacy practices of those third parties, and we encourage you to review their policies before providing personal information.",
                    "In the event of a business transition, such as a merger, acquisition, or restructuring, personal information may be transferred as part of that transaction, subject to applicable requirements.",
                ],
            },
            {
                id: "data-security",
                title: "Data Security",
                paragraphs: [
                    "We take reasonable administrative, technical, and organizational measures designed to protect personal information from unauthorized access, disclosure, alteration, or loss.",
                    "However, no method of transmission over the internet or method of electronic storage is completely secure. While we work to safeguard information, we cannot ensure absolute security of data transmitted to or stored by us.",
                    "You are responsible for maintaining the confidentiality of any credentials or access details associated with your use of our services, where applicable.",
                    "If you believe your interaction with us is no longer secure, please contact us using the details provided below so we can review the matter.",
                ],
            },
            {
                id: "your-rights",
                title: "Your Rights",
                paragraphs: [
                    "Depending on your location and applicable law, you may have certain choices regarding the personal information we hold about you. These may include the ability to request access, correction, or deletion of your information.",
                    "You may also be able to opt out of receiving marketing communications from us by following the unsubscribe instructions in those messages or by contacting us directly.",
                    "To submit a request related to your personal information, please use the contact details provided in this policy. We may need to verify your identity before responding to certain requests.",
                    "We will consider and respond to requests in accordance with applicable legal requirements and our internal procedures.",
                ],
            },
            {
                id: "policy-changes",
                title: "Changes to This Privacy Policy",
                paragraphs: [
                    "We may update this Privacy Policy from time to time to reflect changes in our practices, services, or operational needs. When we make changes, we will revise the effective date or post an updated version on this page.",
                    "We encourage you to review this policy periodically to stay informed about how we may handle personal information. Continued use of our website after changes are posted may indicate your acknowledgment of the updated policy.",
                    "If we make material changes that significantly affect how personal information is handled, we may provide additional notice where appropriate.",
                ],
            },
            {
                id: "contact-us",
                title: "Contact Us",
                paragraphs: [
                    "If you have questions about this Privacy Policy or how we handle personal information, please contact us using the contact options available on our website.",
                    "When reaching out, please include enough detail for us to understand and respond to your inquiry. We aim to review and address reasonable requests in a timely manner.",
                    "For general business inquiries, you may also use the contact information listed on our website. We appreciate your interest in our privacy practices and welcome your feedback.",
                ],
            },
        ],
    },
    terms: {
        title: "Terms & Conditions",
        subtitle: "These terms govern access to and use of this website. Please read them carefully before using our site.",
        onThisPage: "On this page",
        sections: [
            {
                id: "introduction",
                title: "Introduction",
                paragraphs: [
                    "These Terms and Conditions govern your access to and use of this website. By visiting or using our site, you agree to be bound by these terms and our related policies.",
                    "This website is provided for general informational purposes. The content on this site may describe our business, products, services, and other topics of interest to our visitors.",
                    "Please read these terms carefully before using the website. If you do not agree with any part of these terms, you should discontinue use of the site.",
                ],
            },
            {
                id: "acceptance-of-terms",
                title: "Acceptance of Terms",
                paragraphs: [
                    "By accessing or using this website, you confirm that you have read, understood, and agree to these Terms and Conditions. Your continued use of the site constitutes ongoing acceptance of these terms.",
                    "If you are using this website on behalf of an organization, you represent that you have the authority to bind that organization to these terms.",
                    "We may update these terms from time to time. When changes are posted, your continued use of the website may indicate your acceptance of the revised terms.",
                ],
            },
            {
                id: "use-of-the-website",
                title: "Use of the Website",
                paragraphs: [
                    "You may use this website for lawful purposes and in a manner consistent with these terms. You agree not to use the site in any way that could damage, disable, overburden, or impair its operation.",
                    "You may not attempt to gain unauthorized access to any part of the website, related systems, or networks. You also agree not to interfere with the security or integrity of the site or its content.",
                    "We reserve the right to restrict or terminate access to the website at any time, with or without notice, if we believe use of the site violates these terms or poses a risk to the site or other users.",
                    "Information on this website is provided on a general basis and may be changed or updated without prior notice. We do not guarantee that the site will be available at all times or free from errors or interruptions.",
                ],
            },
            {
                id: "intellectual-property",
                title: "Intellectual Property",
                paragraphs: [
                    "All content on this website, including text, graphics, logos, images, layouts, and other materials, is owned by us or used with permission and is protected by applicable intellectual property laws.",
                    "You may view and download content from this website for personal, non-commercial use only, unless otherwise permitted in writing. You may not copy, reproduce, distribute, modify, or create derivative works from site content without prior authorization.",
                    "Trademarks, service marks, and trade names displayed on this website may not be used without the prior written consent of the respective owner.",
                    "Unauthorized use of any materials on this website may violate copyright, trademark, or other applicable laws and could result in legal action.",
                ],
            },
            {
                id: "user-responsibilities",
                title: "User Responsibilities",
                paragraphs: [
                    "You are responsible for ensuring that any information you submit through this website is accurate, complete, and appropriate. You agree not to submit false, misleading, or unlawful content.",
                    "If you contact us through forms, email, or other channels linked from this site, you agree to communicate respectfully and not to transmit harmful, offensive, or unauthorized material.",
                    "You are responsible for maintaining the confidentiality of any account credentials or access details associated with your use of our services, where applicable.",
                    "You agree to comply with all applicable laws and regulations when using this website and when interacting with us through any online channels we provide.",
                ],
            },
            {
                id: "limitation-of-liability",
                title: "Limitation of Liability",
                paragraphs: [
                    "This website and its content are provided on an \"as is\" and \"as available\" basis. To the fullest extent permitted by applicable law, we disclaim all warranties, whether express or implied, regarding the site and its content.",
                    "We do not warrant that the website will be uninterrupted, error-free, secure, or free from viruses or other harmful components. You use the site at your own risk.",
                    "To the maximum extent permitted by applicable law, we shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from or related to your use of this website.",
                    "Nothing in these terms excludes or limits liability where such exclusion or limitation is not permitted by applicable law.",
                ],
            },
            {
                id: "third-party-links",
                title: "Third-Party Links",
                paragraphs: [
                    "This website may contain links to third-party websites or services that are not owned or controlled by us. These links are provided for convenience and informational purposes only.",
                    "We do not endorse and are not responsible for the content, policies, practices, or availability of any third-party sites or services. Your use of third-party websites is at your own discretion and risk.",
                    "We encourage you to review the terms and privacy policies of any third-party websites you visit. We are not liable for any loss or damage arising from your use of or reliance on third-party content or services.",
                ],
            },
            {
                id: "changes-to-these-terms",
                title: "Changes to These Terms",
                paragraphs: [
                    "We may revise these Terms and Conditions at any time to reflect changes in our website, business practices, or legal requirements. Updated terms will be posted on this page with a revised effective date where applicable.",
                    "It is your responsibility to review these terms periodically. Continued use of the website after changes are posted may constitute your acceptance of the updated terms.",
                    "If we make material changes, we may provide additional notice on the website or through other reasonable means where appropriate.",
                ],
            },
            {
                id: "governing-law",
                title: "Governing Law",
                paragraphs: [
                    "These Terms and Conditions shall be governed by and interpreted in accordance with applicable laws, without regard to conflict of law principles.",
                    "Any dispute arising out of or relating to these terms or your use of this website shall be subject to the jurisdiction of the courts or tribunals designated by applicable law.",
                    "If any provision of these terms is found to be invalid or unenforceable, the remaining provisions shall continue in full force and effect to the extent permitted by applicable law.",
                ],
            },
            {
                id: "contact-us",
                title: "Contact Us",
                paragraphs: [
                    "If you have questions about these Terms and Conditions or your use of this website, please contact us using the contact options available on our website.",
                    "When reaching out, please include sufficient detail so we can understand and respond to your inquiry. We aim to review and address reasonable requests in a timely manner.",
                    "For general business inquiries, you may also use the contact information listed on our website. We appreciate your interest and welcome your feedback.",
                ],
            },
        ],
    },
    crops: ["Grapes", "Pomegranate", "Banana", "Cotton", "Tomato", "Soybean", "Sugarcane", "Vegetables", "Onion", "Chili", "Other"],
};
